import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance9000 } from "../../api/axiosInstance";
import { normalizeApiError } from "../../api/apiError";

export const fetchClaimReport = createAsyncThunk(
  "claim/fetchClaimReport",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.get("/api/branch/claim/report/detail", {
        params: { id },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(normalizeApiError(error, "Gagal memuat detail klaim."));
    }
  }
);

const claimReportSlice = createSlice({
  name: "claimDetail",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClaimReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClaimReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchClaimReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default claimReportSlice.reducer;
